import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Admin/Integration/ShopifyIntegration/ShopifyHome';

const ShopifyHome = () => ((orgContainer(InnerComponent)));
export default ShopifyHome;
